import { useEffect, useRef, useState } from "react";
import { Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const WaitingToJoinScreen = () => {
  const { t } = useTranslation();
  const waitingMessages = [
    { index: 0, text: t("video.waitingMessageLoading") },
    { index: 1, text: t("video.waitingMessageAlmostThere") },
  ];
  const [message, setMessage] = useState(waitingMessages[0]);

  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setMessage((s) => (s.index === waitingMessages.length - 1
        ? s
        : waitingMessages[s.index + 1]));
    }, 3000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <Flex justify="center" align="center" style={{ width: "100%", height: "100%" }}>
      <Title level={1} style={{ margin: 0 }}>{message.text}</Title>
    </Flex>
  );
};

export default WaitingToJoinScreen;
